import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import Image from '@nerdwallet/react-image';

const PressLogoTile = ({
  company,
  image,
  height,
  width,
  naturalHeight,
  naturalWidth,
}) => {
  const dimensionsStyle = {
    maxHeight: `${height}`,
    maxWidth: `${width}`,
    margin: '0 auto',
  };

  return (
    <div className={classNames(['logo-nav__tile'])}>
      <Image
        src={image}
        alt={company}
        backgroundColor="transparent"
        className={classNames([
          classes('padding-horizontal-4'),
          classes('padding-vertical-4'),
        ])}
        imageClassName="logo-nav__image"
        naturalHeight={naturalHeight}
        naturalWidth={naturalWidth}
        style={dimensionsStyle}
      />
    </div>
  );
};

PressLogoTile.propTypes = {
  company: PropTypes.string,
  image: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  naturalHeight: PropTypes.number,
  naturalWidth: PropTypes.number,
};

PressLogoTile.displayName = 'PressLogoTile';

export default PressLogoTile;
